import css from "standard/css";

const style = css`
  .resendEmail {
    color: var(--color-primary);
    font-family: var(--font-family-base);
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-lg);
    text-decoration: none;
  }
`;

export default style;
